<template>
  <section>
    <section class="collection-text">
      <div class="title-holder">
        <h1>
          Zoekresultaten voor "{{ printStoreStore.searchOptions.searchString }}"
        </h1>
      </div>
    </section>
    <main-title
      :title="noResultsTitle"
      :subTitle="noResultsText"
      v-if="!searchInProgress && products.length < 1"
    >
    </main-title>

    <card-holder v-else>
      <template v-for="item in products">
        <collection-card
          v-if="item.objectType === 'COLLECTION'"
          :key="item.id"
          :value="item"
          @removed="removeItem(item.id)"
          @click.native="goToCollection(item.id, item.categoryIds[0])"
        >
        </collection-card>

        <package-card
          v-if="item.objectType === 'PACKAGE'"
          :key="item.id"
          :value="item"
          @removed="removeItem(item.id)"
        >
        </package-card>

        <product-card
          v-if="item.objectType === 'PRODUCT'"
          :key="item.id"
          :value="item"
          @removed="removeItem"
        >
        </product-card>
      </template>
    </card-holder>
  </section>
</template>

<script>
//import CardHolder from './CardHolder.vue'
import CollectionCard from '@/features/printstore/children/CollectionCard.vue'
import PackageCard from '@/features/printstore/children/PackageCard.vue'
import MainTitle from './MainTitle.vue'
import ProductCard from '@/features/printstore/children/ProductCard.vue'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  components: {
    ProductCard,
    CollectionCard,
    //CardHolder,
    PackageCard,
    MainTitle
  },
  data() {
    return {
      noResultsTitle: 'Niets gevonden',
      noResultsText: 'Controleer de spelling of zoek op alternatieve termen.'
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    searchInProgress() {
      return this.printStoreStore.searchInProgress
    },
    products() {
      return this.printStoreStore.searchResults.map((item) => item.product)
    }
  },
  methods: {
    removeItem(id) {
      this.printStoreStore.removeFromSearchResults(id)
    },
    async goToCollection(id, categoryId) {
      await this.$router.push({
        name: 'printStoreCollection',
        params: { categoryId: categoryId, collectionId: id }
      })
    },
    collectionUpdated(collection) {
      this.goToCollection(collection.id, collection.categoryId)
    }
  }
}
</script>

<style scoped lang="scss">
.db-search {
  margin: 25px auto;
}

h1 {
  padding-bottom: 15px;
  padding-left: 20px;
  margin-bottom: 0;
  font-size: 30px;
  color: var(--sub-color);
  flex-grow: 1;
  word-break: break-word;
  line-height: 34px;
}
</style>
